import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import {
    InfoOutlined,
    Warning,
    Done,
    Update,
    ThumbUp,
} from '@mui/icons-material';

import StatsCard from './StatsCard';

export interface VersionCardProps {
    used_version?: any;
    latest_version?: any;
    title?: React.ReactNode;
}
function VersionCard(props: VersionCardProps) {
    const { t } = useTranslation();
    const { used_version, latest_version, title } = props;
    if (!used_version || !latest_version) {
        return (
            <StatsCard
                icon={Update}
                iconColor="orange"
                title={title}
                description={used_version || t('LOADING')}
                statIcon={Update}
                statIconColor="gray"
                statText={t('WAITING_FOR_VERSION')}
            />
        );
    } else if (used_version === latest_version) {
        return (
            <StatsCard
                icon={ThumbUp}
                iconColor="green"
                title={title}
                description={used_version}
                statIcon={Done}
                statText={t('UP_TO_DATE_GOOD_JOB_ADMIN')}
            />
        );
    } else {
        return (
            <StatsCard
                icon={InfoOutlined}
                iconColor="red"
                title={title}
                description={used_version}
                statIcon={Warning}
                statIconColor="danger"
                statText={
                    <Trans
                        i18nKey="VERSION_X_AVAILABLE"
                        latest_version={latest_version}
                    >
                        Version {{ latest_version }} available
                    </Trans>
                }
            />
        );
    }
}

VersionCard.defaultProps = {
    iconColor: 'purple',
    statIconColor: 'gray',
};

export default VersionCard;
